import { Moment } from 'moment';

export function momentToDateStr(moment?: Moment): string {
  if (moment == null) {
    return null;
  }

  return moment.format('YYYY-MM-DD');
}
